export default "__VITE_ASSET__CP3GlXQP__"